<template>
  <span
    class="animate-spin rounded-full border-t-2 border-b-2"
    :style="{
      width: size,
      height: size,
      borderColor: color,
      borderLeftColor: 'transparent',
      borderRightColor: 'transparent'
    }"
  ></span>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps<{
  size?: number | string
  color?: string
}>()

const color = computed(() => props.color || 'var(--c-primary-600)')

const size = computed(() => {
  if (!props.size) return '2rem'
  const match = `${props.size}`.toLowerCase().replace(/\s*/, '').match(/(\d+)(px|em|rem|%)?/)
  return `${match?.[1] || 32}${match?.[2] || 'px'}`
})
</script>
